import sticky from "./sticky";
import embedVideo from "./embed-video";
import jumplinks from "./jumplinks";

export default function () {
    sticky();
    embedVideo();
    jumplinks();
}
